import script from "./standard-opening-hours.vue?vue&type=script&setup=true&lang=js"
export * from "./standard-opening-hours.vue?vue&type=script&setup=true&lang=js"

import "./standard-opening-hours.vue?vue&type=style&index=0&id=d97165f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d97165f2"]])

export default __exports__